<template>
	<div id="index" ref="appRef">
		<div class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<Header />
				<div class="line"></div>
				<iframe src="https://www.91ipr.top/map/scatter.html" id="mobsf" scrolling="no" frameborder="0" class="iframe" :style="{height:height}"></iframe> 
			</div>
		</div>
	</div>
</template>

<script>
	import drawMixin from "../utils/drawMixin";
	import Header from './header'
	export default {
		mixins: [drawMixin],
		data() {
			return {
				loading: true, //加载状态
				height:'',
			};
		},
		components: {
			Header
		},
		mounted() {
		   /** * iframe-宽高自适应显示 */
			this.cancelLoading();
			this.changeMobsfIframe() 
			window.onresize = function(){ 
				this.changeMobsfIframe() 
			}
			document.querySelector('body').setAttribute('style', 'background-color:#000088;')
		},
		beforeDestroy() {
			document.querySelector('body').setAttribute('style', 'background-color:#020308;')
		},
		methods: {
			changeMobsfIframe() {
				// const deviceWidth = document.body.clientWidth;
				const deviceHeight = document.body.clientHeight;
				// console.log(Number(deviceWidth) - 240)
				this.height = (Number(deviceHeight)- 30) + 'px'
			},
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.bg {
		background:#000088;
	}
	.line{
		width: 100%;
		border-bottom: 1px solid rgba(255,255,255,0.4);
	}
	.iframe{
		position:absolute;
		top:110px;
		left:0;
		right:0px;
		bottom:0;
		width: 100%;
	}
</style>

